
const errors = {
    noAudioDevices: { permission: true, type: 'error', message: 'No Audio Devices found' },
    noVideoDevices: { permission: true, type: 'error', message: 'No Video Devices found' },
    permissionIssue: {
        message: "There was an issue with accessing your camera and/or microphone device, please make sure that permission has been granted for your browser to access your camera and microphone device.",
        permission: false,
        type: 'warning'
    }
}


const state = () => ({
    devices: [],
    audioDevices: [],
    videoDevices: [],
    selectedAudioDevice: null,
    selectedVideoDevice: null,
    audioError: undefined,
    videoError: undefined
})

const filterMediaDevicesOnCategory = (mediaDevices, category) => {
    return mediaDevices.filter(
        (device) => device.kind === category && device.label
    );
}

const actions = {
    getSelectedAudioDevice: () => {
        return state.audioDevices[0].deviceId;
    },

    getSelectedVideoDevice: () => {
        return state.videoDevices[0].deviceId;
    }
}

const mutations = {
    async setDevices(state) {
        try {
            await navigator.mediaDevices.getUserMedia({ audio: true, video: true });
            const devices = await navigator.mediaDevices.enumerateDevices();
            this.commit("devices/setAudioDevices", devices);
            this.commit("devices/setVideoDevices", devices);
        } catch (error) {
            state.audioDevices = [];
            state.selectedAudioDevice = null;
            state.videoDevices = [];
            state.setSelectedVideoDevice = null;
            state.audioError = state.videoError = errors.permissionIssue;
        }

    },

    async setAudioDevices(state, devices) {
        try {
            if (!(devices && devices.length)) {
                await navigator.mediaDevices.getUserMedia({ audio: true });
                devices = await navigator.mediaDevices.enumerateDevices();

            }
            state.audioDevices = filterMediaDevicesOnCategory(
                devices,
                'audioinput'
            );
            this.commit("devices/setSelectedAudioDevice", state.selectedAudioDevice);
            if (state.audioDevices.length == 0) {
                state.audioError = errors.noAudioDevices;
            }else{
                state.audioError=null;
            }
        } catch (error) {
            state.audioDevices = [];
            state.selectedAudioDevice = null;
            state.audioError = errors.permissionIssue;
        }
    },
    async setVideoDevices(state, devices) {
        try {
            if (!(devices && devices.length)) {
                await navigator.mediaDevices.getUserMedia({ video: true });
                devices = await navigator.mediaDevices.enumerateDevices();
            }
            state.videoDevices = filterMediaDevicesOnCategory(
                devices,
                'videoinput'
            );
            this.commit("devices/setSelectedVideoDevice", state.selectedVideoDevice);
            if (state.videoDevices.length == 0) {
                state.videoError = errors.noVideoDevices;
            }else{
                state.videoError= null;
            }
        } catch (error) {
            state.videoDevices = [];
            state.setSelectedVideoDevice = null;
            state.videoError = errors.permissionIssue;
        }
    },
    setSelectedAudioDevice: (state, deviceId) => {
        state.selectedAudioDevice = deviceId || state.audioDevices[0].deviceId;
    },

    setSelectedVideoDevice: (state, deviceId) => {
        state.selectedVideoDevice = deviceId ? deviceId : state.videoDevices[0].deviceId;
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}